import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { retry, catchError } from "rxjs/operators";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  // URL API
  apiURL = environment.apiUrl;
  userId: number;
  userRol: string;
  userName: string;
  userLastname: string;
  settings: Boolean; 
  layers: Boolean; 
  search: Boolean; 
  createActive: Boolean; 
  views: Boolean; 
  zoom: Boolean;
  mLine: Boolean; 
  mPol: Boolean; 

  constructor(private http: HttpClient) {}
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  getuserId() {
    return this.userId;
  }

  getUserRol(){
    return this.userRol;
  }

  login(user: any): Observable<any> {
    return this.http
      .post(this.apiURL + "/getUsuarioRealGis", user)
      .pipe(retry(1), catchError(this.handleError));
  }

  handleError(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Hay un error en la validacion del usuario debido al servidor!\nCodigo Error: ${error.status}\nMessage: ${error.message}`;
      window.location.reload();
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
